import type { MutableRefObject } from 'react';
import { useScroll, useTransform } from 'framer-motion';
import type { MotionValue } from 'framer-motion';

type TpUseScrollAnimation = {
  opacity?: MotionValue<number>;
  transform: MotionValue<string>;
};

type PpuseScrollAnimationValues = {
  opacity: number[];
  scrollThreshold?: number;
  transform: string[];
};

export function useScrollAnimation(
  containerRef: MutableRefObject<null>,
  values: PpuseScrollAnimationValues,
): TpUseScrollAnimation {
  const { scrollYProgress } = useScroll({
    offset: ['start end', 'end start'],
    target: containerRef,
  });
  const opacity = useTransform(
    scrollYProgress,
    [0, values.scrollThreshold || 0.25],
    values.opacity,
  );
  const transform = useTransform(
    scrollYProgress,
    [0, values.scrollThreshold || 0.25],
    values.transform,
  );

  return { opacity, transform };
}
